import React from "react";
import { CheckIcon } from "lucide-react";
import { volumes, weeks, images } from "../data/content";
import { CtaButton } from "./CtaButton";
export function VolumesSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-337" data-mp="co96vbaphkmv">
      <div className="mx-auto max-w-4xl" data-id="element-338" data-mp="cmes6eq12or8">
        <div className="text-center" data-id="element-339" data-mp="7owkernqyfkt">
          <p className="text-sm font-bold uppercase tracking-wider text-gold-dark" data-id="element-340" data-mp="7pxt4phaipzd">What’s inside</p>
          <h2 className="mt-3 font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-341" data-mp="3g5rdjfeqsllp">The 6 volumes of The Sexual Control Protocol™</h2>
        </div>

        <img src={images.mainMockup} alt="All six volumes of The Sexual Control Protocol" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-342" data-mp="3pvatodb2m1cv" />

        <div className="mt-10 space-y-6" data-id="element-343" data-mp="3l2re5astow5f">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_1px_0_rgba(11,26,46,0.06),0_12px_32px_-16px_rgba(11,26,46,0.18)]" data-id="element-344" data-mp="2xdorfojc0d42">
              <div className="flex items-center gap-4 bg-ink px-6 py-5" data-id="element-345" data-mp="29fs40f66y99x">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gold font-serif text-xl font-black text-ink" data-id="element-346" data-mp="29de9q8jc513f">{v.number}</span>
                <div data-id="element-347" data-mp="2j6d2m2lv7dsu">
                  <p className="text-xs font-bold uppercase tracking-wider text-teal" data-id="element-348" data-mp="2j63jmyz8m6wn">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-black leading-tight text-white sm:text-2xl" data-id="element-349" data-mp="2o6hhxpb1e2hh">{v.title}</h3>
                </div>
              </div>
              <div className="p-6 sm:p-8" data-id="element-350" data-mp="1vexv7vf8e6aq">
                <p className="font-serif text-lg font-bold italic text-gold-dark" data-id="element-351" data-mp="1vhtqtd3lwiw0">{v.tagline}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-352" data-mp="20diwzza4sy1a">{v.description}</p>

                {v.number === "IV" && <ol className="mt-6 space-y-3" data-id="element-353" data-mp="3bu92than7nud">
                    {weeks.map(w => <li key={w.week} className="flex gap-4 rounded-2xl border border-ink/10 p-4" data-id="element-354" data-mp="3fvau9bybivls">
                        <span className="w-16 shrink-0 text-xs font-bold uppercase tracking-wider text-ink/50" data-id="element-355" data-mp="1gqkln80mr2pu">{w.week}</span>
                        <div data-id="element-356" data-mp="1bqofp38dh17n">
                          <p className="font-bold text-ink" data-id="element-357" data-mp="1brgcghdph4zi">{w.name}</p>
                          <p className="text-sm text-ink/70" data-id="element-358" data-mp="1pqg1hq54rlw7">{w.text}</p>
                        </div>
                      </li>)}
                  </ol>}

                <p className="mt-6 text-sm font-bold uppercase tracking-wider text-ink/50" data-id="element-359" data-mp="x2249clv8tlp">Inside:</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-360" data-mp="t29pgi5vpr7w">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] text-ink/85" data-id="element-361" data-mp="16u7scb8zyqvm">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-362" data-mp="1214vnu8xb1b7" />
                      <span data-id="element-363" data-mp="eaizp1c717hk">{item}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-364" data-mp="2kzjlduahgx2c">
          <CtaButton label="I want all 6 volumes" data-id="element-365" data-mp="2kzb9a4m6pvs7" />
        </div>
      </div>
    </section>;
}